import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { cn } from "../../../client/cn";

const Root = DropdownMenuPrimitive.Root;
const Trigger = DropdownMenuPrimitive.Trigger;
const Portal = DropdownMenuPrimitive.Portal;

function Content({
  className,
  sideOffset = 4,
  ...props
}: DropdownMenuPrimitive.DropdownMenuContentProps) {
  return (
    <DropdownMenuPrimitive.Content
      sideOffset={sideOffset}
      className={cn(
        "z-50 min-w-[10rem] overflow-hidden rounded-lg border border-border-primary bg-white p-1 shadow-lg dark:border-strokedark dark:bg-boxdark",
        className,
      )}
      {...props}
    />
  );
}

function Item({
  className,
  ...props
}: DropdownMenuPrimitive.DropdownMenuItemProps) {
  return (
    <DropdownMenuPrimitive.Item
      className={cn(
        "flex cursor-pointer select-none items-center rounded-md px-3 py-2 text-sm text-text-primary outline-none transition-colors data-[highlighted]:bg-primary/10 data-[highlighted]:text-primary dark:text-white dark:data-[highlighted]:bg-primary/20 dark:data-[highlighted]:text-primary-200",
        className,
      )}
      {...props}
    />
  );
}

export const DropdownMenu = {
  Root,
  Trigger,
  Portal,
  Content,
  Item,
};
